import React from 'react'
import { kgDivision } from '../../../Store'

const BidList = ({ bidList }) => {
    
    const getNameById = (kgKubun) => {
        const item = kgDivision.find((item) => kgKubun == item.id)
        return item ? item.name : 'Not Found'
    }
    const kgKubunName = getNameById(bidList.kgKubun)
    
    return (
        <div style={{backgroundColor:'#fff', padding : '10px', paddingLeft : '20px', borderBottom: '1px solid'}}>
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'bold'}}>{`【${ bidList.senmei }】`}</div>
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`Kg数量：${bidList.kgSuryo} / 数量：${ bidList.suryo }`}</div>
            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`容器：${ bidList.yoki } / `}{`備考：${ bidList.displayBiko }`}</div>
        </div>
        
    )
  }
  
  export default BidList
